import { render } from "./struct.vue?vue&type=template&id=81b6e578&scoped=true"
import script from "./struct.vue?vue&type=script&lang=js"
export * from "./struct.vue?vue&type=script&lang=js"

import "./struct.vue?vue&type=style&index=0&id=81b6e578&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b6e578"]])

export default __exports__